<template>
  <v-row>
    <v-col cols="12">
      <span class="d-block mb-4 body-2 text--secondary font-weight-medium">{{ instance.account.name }}</span>
      <span class="d-block mb-2 body-1 text--secondary font-weight-medium">{{ instance.description }}</span>

      <template v-if="instance.amount_scheme === 'fixed' || readonly">
        <span class="d-block text-h4 text--secondary font-weight-medium">{{ intentAmount | currency(instance.currency) }} {{ instance.currency }}</span>
      </template>

      <template v-else-if="instance.amount_scheme === 'custom'">
        <!-- amount field -->
        <template v-if="!disableCustomAmount">
          <v-text-field v-model="$v.amount.$model" @change="setCustomAmount" class="d-inline-block v-input--lg" autocomplete="off" background-color="white" dense :error="$v.amount.$error" hide-details maxlength="8" outlined persistent-hint :readonly="disableCustomAmount" ref="customAmount" required single-line style="max-width:180px;">
            <template slot="prepend-inner">
              <span class="mr-3 text--secondary font-weight-medium" style="margin-top:3px;">{{ instance.currency }}</span>
            </template>
          </v-text-field>
          <span  class="d-block caption" :class="{ 'red--text': $v.amount.$error }">
            <template v-if="instance.amount_min && instance.amount_max">Ingresa un monto entre {{ instance.amount_min | currency(instance.currency) }} y {{ instance.amount_max | currency(instance.currency)}} {{ instance.currency }}</template>
            <template v-else-if="instance.amount_min">Ingresa un monto mínimo de {{ instance.amount_min | currency(instance.currency) }} {{ instance.currency }}</template>
            <template v-else-if="instance.amount_max">Ingresa un monto máximo de {{ instance.amount_max | currency(instance.currency) }} {{ instance.currency }}</template>
          </span>
        </template>
        <!-- end amount field -->

        <span v-else class="d-block text-h4 text--secondary font-weight-medium">{{ intentAmount | currency(instance.currency) }} {{ instance.currency }}</span>
        <v-btn v-if="disableCustomAmount && (instance.amount_preset ? true : false)" @click="enableCustomAmount" class="d-block mt-3" :color="instance.account.color_background" :ripple="false" text>Cambiar el monto</v-btn>
      </template>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxValue, minValue, numeric, required } from 'vuelidate/lib/validators'

import GenericViewMixin from '../../mixins/GenericViewMixin'

export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    amount: null,
    disableCustomAmount: true
  }),
  computed: mapState({
    intentAmount: state => state.paymentLinks.linksAmount,
    instance: state => state.paymentLinks.linksDetail
  }),
  watch: {
    instance: {
      handler () {
        if (this.readonly) {
          return
        }

        if (this.instance.amount_scheme === 'fixed') {
          this.amount = this.instance.amount
        } else {
          this.amount = this.instance.amount_preset
        }

        this.$store.dispatch('paymentLinks/SET_LINK_AMOUNT', {
          amount: this.amount
        })
      },
      deep: true
    }
  },
  methods: {
    setCustomAmount () {
      /**
       * Sets amount for intent into store
       */
      this.$v.amount.$touch()

      this.$store.dispatch('paymentLinks/SET_LINK_AMOUNT', {
        amount: this.amount
      })
    },
    enableCustomAmount () {
      /**
       * Enables custom amount for payment links.
       * Sets `disableCustomAmount` to `false`.
       * Focuses and selects the input content.
       */
      this.disableCustomAmount = false

      setTimeout(() => {
        const el = this.$refs.customAmount.$el.querySelector('input')
        el.focus()
        el.select()
      }, 500)
    }
  },
  validations: {
    amount: {
      required,
      numeric,
      maxValue: function () {
        return this.instance.amount_max ? maxValue(this.instance.amount_max)(this.amount) : () => true
      },
      minValue: function () {
        return this.instance.amount_min ? minValue(this.instance.amount_min)(this.amount) : () => true
      }
    }
  }
}
</script>